//#region imports
import customAxios from '../../../utils/customAxios';
import { useState, useEffect } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

import { Stack } from '@mui/system';

import { GlobalVariables } from '../../../globalVar';

import { useTableLocale } from '../../../hooks/useTableLocale';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from '@mui/material';
import CreateClientTiModal from '../../Modal/Sigma/ClientTi/CreateClientTiModal';
import UpdateClientTiModal from '../../Modal/Sigma/ClientTi/UpdateClientTiModal';

export const ClientTiTable = () => {
  const [clientTiData, setClientTiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [clientTiId, setClientTiId] = useState(null);

  const { addString } = useTranslationHook();

  const locale = useTableLocale();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const endpoint = `${GlobalVariables.getURL()}client-ti/listAllClientTi`;
    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      if (response.status === 204) {
        setClientTiData([]);
      } else {
        setClientTiData(response.data.data);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const clientTiColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'full_name',
      headerName: 'Nombre',
      width: 250,
    },
    {
      field: 'number',
      headerName: 'Numero',
      width: 120,
    },
    {
      field: 'email',
      headerName: 'Correo',
      width: 220,
    },
    {
      field: 'position',
      headerName: 'Puesto',
      width: 180,
    },
    {
      field: 'created_by',
      headerName: 'Creado por',
      width: 200,
    },
    {
      field: 'created_at',
      headerName: 'Fecha  y hora de creación',
      width: 200,
    },
    {
      field: 'updated_by',
      headerName: 'Actualizado por',
      width: 200,
    },
    {
      field: 'updated_at',
      headerName: 'Fecha  y hora de actualización',
      width: 200,
    },
    {
      field: 'Action',
      headerName: 'Acciones',
      filterable: false,
      width: 180,
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return (
          <div
            className="cellAction visits-datagrid-actions-tour"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
          >
            <Tooltip title={'Editar'} arrow>
              <button
                type="button"
                style={{ background: 'none', border: 'none', padding: 0 }}
                onClick={() => {
                  setClientTiId(row.id);
                  setShowUpdateModal(true);
                }}
              >
                <ModeEditOutlineOutlinedIcon
                  className="detail-icons"
                  id="update-icon"
                />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="datatable" style={{ padding: '0px 16px' }}>
        <div className="datatable-btns-container">
          <div className="dt-btn-main-container">
            <button
              className="add-button create-site-tour"
              onClick={() => setShowCreateModal(true)}
            >
              {addString} <FontAwesomeIcon icon={faAdd} />
            </button>
          </div>
        </div>
        <DataGridPro
          localeText={locale.components.MuiDataGrid.defaultProps.localeText}
          pagination
          showQuickFilter
          loading={isLoading}
          rows={clientTiData}
          columns={clientTiColumns}
          pinnedColumns={{
            right: ['Action'],
          }}
          slots={{
            noRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No hay Contactos de Sucursal registrados
              </Stack>
            ),
            toolbar: GridToolbar,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />

        <CreateClientTiModal
          show={showCreateModal}
          onHide={() => setShowCreateModal(false)}
          getData={getData}
        />

        <UpdateClientTiModal
          show={showUpdateModal}
          onHide={() => setShowUpdateModal(false)}
          getData={getData}
          clientTiId={clientTiId}
        />
      </div>
    </>
  );
};

export default ClientTiTable;
